import FirstApp from './components/FirstApp'
import './App.css';

function App() {
  return (
    <FirstApp/>
  );
}

export default App;
